import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import IndexPage from "../pages/index.page";
import { PersonalInformationPage } from "../pages/2-personal-information/personal-information.page";
import { routes } from "./routes";
import { IntroPage } from "../pages/1-intro/intro.page";
import { SendPage } from "../pages/9-send/send.page";
import { DonePage } from "../pages/10-done/done.page";
import { NotFoundPage } from "../pages/not-found/not-found.page";
import { DynamicFormPageRoutes } from "./dynamic-form-page-routes";
import { PrivacyPage } from "../pages/privacy/privacy.page";
import { ImprintPage } from "../pages/imprint/imprint.page";
import { AlmostDonePage } from "../pages/6-almost-done/almost-done.page";
import { CancelAppointmentPage } from "../pages/7-cancel-appointment/cancel-appointment.page";
import { AdditionalPaymentPage } from "../pages/8-additional-payment/additional-payment.page";
import { InfoPage } from "../pages/8-info/info.page";
import { FlowDefinition } from "../flows/types";

export const createAppRouter = (flow: FlowDefinition) =>
  createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path={routes.privacy} element={<PrivacyPage />} />
        <Route path={routes.imprint} element={<ImprintPage />} />
        <Route element={<IndexPage />}>
          <Route path={routes.questionnaire.base} element={<IntroPage />} />
          <Route
            path={routes.questionnaire.personalInformation}
            element={<PersonalInformationPage />}
          />
          {flow.pages?.map((page) => (
            <Route key={page.path} path={page.path} element={page.element} />
          ))}
          {flow.questionnaires.map((questionnaireData, index) => (
            <Route key={index}>
              {...DynamicFormPageRoutes({ questionnaireData })}
            </Route>
          ))}
          <Route
            path={routes.questionnaire.almostDone}
            element={<AlmostDonePage />}
          />
          <Route
            path={routes.questionnaire.cancelAppointment}
            element={<CancelAppointmentPage />}
          />
          <Route
            path={routes.questionnaire.additionalPayment}
            element={<AdditionalPaymentPage />}
          />
          <Route
            path={`${routes.questionnaire.info}/:id`}
            element={<InfoPage />}
          />
          <Route path={routes.questionnaire.send} element={<SendPage />} />
          <Route path={routes.questionnaire.done} element={<DonePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Route>,
    ),
  );
